import React, { useState } from 'react';
import update from 'react-addons-update';
import { Redirect } from 'react-router-dom'

import Modal from '../../../common/components/Modal';
import NotifcationActions from '../../../common/flux/NotificationActions.js';
import RestrictedComponent from '../../../lib/components/form/RestrictedComponent';
import schema from '../../../routes/permissions/schema';

const Technician = props => {
    const [deleteModal, setDeleteModal] = useState(false)
    const [editModal, setEditModal] = useState(false)
    const [validators, setValidators] = useState([])
    const [edited, setEdited] = useState(false)
    const [edits, setEdits] = useState({})
    const [redirect, setRedirect] = useState(false)
    
    const selectTechnician = () => {
        if (props.mode == 'event') props.assignTechnicianToEvent();
    }

    const toggleDeleteModal = () => {
        setDeleteModal(!deleteModal)
    }

    const toggleEditModal = () => {
        if (editModal) revert();
        setEditModal(!editModal)
    }

    const revert = () => {
        setDeleteModal(false)
        setEditModal(false)
        setValidators([])
        setEdited(false)
        setEdits({})
    }

    const save = () => {
        if (!valid()) return;
        toggleEditModal();
        props.actions.edit({
            techID: props.technician.techID,
            techName: edits.techName
        });
    }

    const valid = () => {
        var failed = [], messages = [];

        if (edited && edits.techName === '') {
            failed.push('techName');
            messages.push('Technician Name is Required');
        }

        if (failed.length) {
            setValidators(failed)

            NotifcationActions.notify({
                type: 'warning',
                messages: messages
            });

            return false;
        }

        return true;
    }

    const deleteTechnician = () => {
        toggleDeleteModal();
        props.actions.delete({
            techID: props.technician.techID
        });
    }

    const handleChange = (event) => {
        if (!edited) {
            setEdited(true)
            setEdits(prev => ({...prev, techName: props.technician.techName}))
        }

        var updates = {};
        updates[event.target.name] = {$set: event.target.value};
        setEdits(prev => update(prev, updates))
    }

    const showSchedule = (event) => {
        setRedirect('/manage/technicians/schedule?id=' + props.technician.techID)
    }


    const renderActions = () => {
        switch (props.mode) {
            case 'event':
                return (
                    <div className="btn-group" role="group">
                        <RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_TECHNICIANS.READ}>
                            <button type="button" className="btn btn-default" onClick={showSchedule}>
                                <i className="fa fa-print"/> View Schedule
                            </button>
                        </RestrictedComponent>
                        <RestrictedComponent permissionCheck='event_tab_technicians.update'>
                            <button type="button" className="btn btn-default" onClick={selectTechnician}>
                                <i className="fa fa-check"/> Assign
                            </button>
                        </RestrictedComponent>
                    </div>
                );

            case 'manage':
                return (
                    <div className="btn-group" role="group">
                        <RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_TECHNICIANS.READ}>
                            <button type="button" className="btn btn-default" onClick={showSchedule}>
                                <i className="fa fa-print"/> View Schedule
                            </button>
                        </RestrictedComponent>
                        <RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_TECHNICIANS.UPDATE}>
                            <button type="button" className="btn btn-default" onClick={toggleEditModal}>
                                <i className="fa fa-pencil"/> Edit
                            </button>
                        </RestrictedComponent>
                        <RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_TECHNICIANS.DELETE}>
                            <button type="button" className="btn btn-default" onClick={toggleDeleteModal}>
                                <i className="fa fa-trash-can"/> Delete
                            </button>
                        </RestrictedComponent>
                    </div>
                );
        }
    }

    const renderModals = () => {
        if (editModal) {

            var techName = (edited) ?
                edits.techName :
                props.technician.techName;

            return (
                <Modal
                    saveAction={<button className="btn btn-primary" onClick={save} disabled={!edited}><i className="fa fa-save"/> Save</button>}
                    cancelModal={toggleEditModal}>
                    <Modal.Header>Edit Technician</Modal.Header>
                    <Modal.Body>
                        <label>Technician Name</label>
                        <input className="form-control" name="techName" value={techName} onChange={handleChange} />

                        <div style={{margin: '2rem 0'}}/>
                    </Modal.Body>
                    <Modal.Footer></Modal.Footer>
                </Modal>
            );
        } else if (deleteModal) {
            return (
                <Modal
                    saveAction={<button className="btn btn-danger" onClick={deleteTechnician}><i className="fa fa-trash-can"/> Delete</button>}
                    cancelModal={toggleDeleteModal}>
                    <Modal.Header>Delete Technician</Modal.Header>
                    <Modal.Body>
                        <div className="alert alert-danger">
                            <strong>Are you sure?</strong>
                            <p>This cannot be undone!</p>
                        </div>
                    </Modal.Body>
                    <Modal.Footer></Modal.Footer>
                </Modal>
            );
        }
    }
    if (redirect !== false) {
        return <Redirect to={redirect} />
    }
    return (
        <div className="panel panel-default technician">
            <div className="panel-heading">
                <h5>{props.technician.techName}</h5>
            </div>
            <div className="panel-body text-right">
                {renderActions()}
            </div>

            {renderModals()}
        </div>
    );
}

export default Technician;
